import React from "react";
import {ToastNotification} from "@carbon/react";

import './Toast.scss'

import { useToastContext, REMOVE } from './Context/ToastContext';

const Toast = (props) => {
  const toast = props.toast
  const { toastDispatch } = useToastContext();
  return (
    <div className="toast">
      <div className="toast-container">
        {/* Displaying each element of the toast */}
        {toast.map(t => {
          return (
            <ToastNotification
              role="status"
              caption={t.caption}
              timeout={5000}
              kind={t.kind}
              title={t.title}
              subtitle={t.content}
              lowContrast={true}
              key={t.id}
              className="toast-container-item"
              onCloseButtonClick={() => {
                toastDispatch({ type: REMOVE, payload: { id: t.id } })
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Toast